import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  InputAdornment,
  TextField,
  debounce,
} from '@mui/material';

export type SelectOption = {
  value: string;
  label: string;
};

type SearchBarProps = {
  label: string;
  setSearchTerm: (searchTerm: SelectOption | string) => void;
  setTypeaheadSearchTerm?: (searchTerm: string) => void;
  options?: string[] | SelectOption[];
  value?: string;
  isLoading?: boolean;
  disabled?: boolean;
};

export const SearchBar = ({
  label,
  options,
  setSearchTerm,
  setTypeaheadSearchTerm,
  value,
  isLoading = false,
  disabled,
}: SearchBarProps) => {
  const onUserChangedSearchTerm = setTypeaheadSearchTerm
    ? debounce(setTypeaheadSearchTerm, 500)
    : () => null;

  return (
    <Autocomplete
      freeSolo
      selectOnFocus
      disabled={disabled}
      options={options.map(option => (option.label ? { ...option } : option))}
      getOptionDisabled={() => isLoading}
      getOptionLabel={option => {
        if (typeof option === 'string') {
          return option;
        } else {
          return option.label;
        }
      }}
      isOptionEqualToValue={(option, value) => {
        if (typeof option === 'string' || typeof value === 'string') {
          return option === value;
        }
        return option?.value === value?.value;
      }}
      filterOptions={options => options}
      onChange={(event, option) => setSearchTerm(option)}
      onInputChange={(event: any) => {
        onUserChangedSearchTerm(event?.target?.value || '');
      }}
      value={value}
      renderOption={(props, option) => {
        const key =
          typeof option === 'string' ? option : option?.value || option?.label;
        return (
          <li {...props} key={key}>
            {typeof option === 'string' ? option : option?.label || ''}
          </li>
        );
      }}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          placeholder={label}
          label=""
          variant="outlined"
          fullWidth
        />
      )}
    />
  );
};
